import React, { useState, useMemo } from 'react';
import { TERMINAL_THEMES } from '../utils/terminalThemes';
import { setTheme } from './ThemeInitializer';
import './ThemeSelector.css';

function ThemeSelector() {
  const savedId = localStorage.getItem('colorTheme') || 'easy-invoice-theme';
  const [selectedTheme, setSelectedTheme] = useState(savedId);
  const [filter, setFilter] = useState('all'); // 'all' | 'dark' | 'light'

  const filteredThemes = useMemo(() => {
    if (filter === 'dark') return TERMINAL_THEMES.filter(t => t.isDark);
    if (filter === 'light') return TERMINAL_THEMES.filter(t => !t.isDark);
    return TERMINAL_THEMES;
  }, [filter]);

  const darkCount = TERMINAL_THEMES.filter(t => t.isDark).length;
  const lightCount = TERMINAL_THEMES.filter(t => !t.isDark).length;

  const handleThemeChange = (themeId) => {
    setSelectedTheme(themeId);
    setTheme(themeId);
  };

  const currentTheme = TERMINAL_THEMES.find(t => t.id === selectedTheme);

  return (
    <div className="theme-selector-container">
      <div className="theme-controls">
        <div className="theme-filter-buttons">
          <button 
            className={`filter-btn ${filter === 'all' ? 'active' : ''}`}
            onClick={() => setFilter('all')}
          >
            All ({TERMINAL_THEMES.length})
          </button>
          <button 
            className={`filter-btn ${filter === 'light' ? 'active' : ''}`}
            onClick={() => setFilter('light')}
          >
            ☀️ Light ({lightCount})
          </button>
          <button 
            className={`filter-btn ${filter === 'dark' ? 'active' : ''}`}
            onClick={() => setFilter('dark')}
          >
            🌙 Dark ({darkCount})
          </button>
        </div>
      </div>

      <div className="theme-grid">
        {filteredThemes.map(theme => (
          <div
            key={theme.id}
            className={`theme-card ${selectedTheme === theme.id ? 'selected' : ''}`}
            onClick={() => handleThemeChange(theme.id)}
          >
            <div className="theme-card-preview" style={{ backgroundColor: theme.colors.background }}>
              <div className="theme-card-swatches">
                <span style={{ color: theme.colors.text, fontWeight: 700 }}>Aa</span>
                <span style={{ color: theme.colors.primary, fontWeight: 700 }}>Aa</span>
                <div className="swatch-dots">
                  <span className="swatch-dot" style={{ backgroundColor: theme.colors.accent }} />
                  <span className="swatch-dot" style={{ backgroundColor: theme.colors.success }} />
                  <span className="swatch-dot" style={{ backgroundColor: theme.colors.secondary }} />
                </div>
              </div>
            </div>
            <div className="theme-card-name">
              {theme.name}
              {theme.isDark ? ' 🌙' : ' ☀️'}
            </div>
          </div>
        ))}
      </div>

      {currentTheme && (
        <p style={{ fontSize: '0.85rem', color: 'var(--color-text-muted)', marginTop: '1rem' }}>
          Active: <strong>{currentTheme.name}</strong> ({currentTheme.isDark ? 'dark' : 'light'})
        </p>
      )}
    </div>
  );
}

export default ThemeSelector;
